import { useEffect, useState } from 'react';
import { NameValue } from '../types';

export type Func = undefined | null | (() => Promise<any[]>);

function useFetchOptions(fn: Func, defaultValues: NameValue[]): [NameValue[], Error] {
  const [data, setData] = useState(defaultValues ?? []);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (fn == null) {
          return;
        }
        let res = await fn();
        if (res == null) {
          res = [];
        }
        if (!Array.isArray(res)) {
          res = [res];
        }
        setData(res);
      }
      catch (e) {
        setError(e);
      }
    }
    fetchData();
  }, [fn]);

  return [data, error];
}

export default useFetchOptions;
